import type { AccountUserWithDetail } from '@/generated/hey-api/types.gen';

export type PostLoginDestination = '/talent/jobs' | '/client' | '/client/home' | '/admin';

/**
 * Where to send a user after authentication completes.
 *
 * - Talent → talent jobs board
 * - Admin (platform operator) → admin surface (`/admin`)
 * - Services-business client → landing page (`/client`)
 * - Product-business client → dashboard (`/client/home`)
 *
 * Mirrors the guard in `_authenticated/client/_dashboard.tsx`: only product
 * clients are allowed onto the dashboard.
 */
export function postLoginDestination(user: AccountUserWithDetail): PostLoginDestination {
	if (user.role === 'talent') return '/talent/jobs';
	if (user.role === 'admin') return '/admin';
	if (user.role === 'client' && user.client_account?.client_type !== 'product') return '/client';
	return '/client/home';
}
